import styles from './header.module.css';

class Header extends HTMLElement {
    connectedCallback(): void {
        this.render();
    }

    render(): void {
        this.innerHTML = `
            <header class="${styles.header}">
                <div class="${styles.headerContainer}">

                </div>
            </header>
        `;
    }
}

// Register the custom element
customElements.define('header-component', Header);

export { Header };
